/**
 * @file useDimension 获取数据点
 */
import { useRegionInstance } from '../context/reigon';
export function usePoint(part) {
  var region = useRegionInstance();
  return region.getPoint(part);
}